import { useNavigate } from "react-router";
import { useDrops } from "../../store/useDrops";
import dayjs from "dayjs";
import { Tooltip } from "@material-tailwind/react";
import { ReactComponent as EditIcon } from "../../assets/icons/tables/edit-icon.svg";
import { ReactComponent as TrashIcon } from "../../assets/icons/tables/trash-icon.svg";

interface Props {
  userId: string;
}

export const UserDropsList = ({ userId }: Props) => {
  /** Hooks */
  const { userDrops: drops, deleteDrop } = useDrops();
  const navigate = useNavigate();

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-3">
              Drop
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-3"
            >
              Location
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-3">
              Price
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-3"
            >
              Feedbacks
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-3"
            >
              Status
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-3"
            >
              Date
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-3 text-right">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {drops?.map((drop) => {
            // const openDropDetails = () => navigate("/drop-details/292010");
            const isApproved = drop?.status === "approved";
            const isDeclined = drop?.status === "declined";
            const isPending = drop?.status === "pending";

            return (
              <tr
                key={drop?._id}
                className="bg-white border-b cursor-pointer hover:bg-gray-50"
              // onClick={openDropDetails}
              >
                <th
                  scope="row"
                  className="px-2 sm:px-6 py-1 sm:py-4 text-xs sm:text-base font-bold text-primary-base whitespace-nowrap"
                >
                  #{drop?._id}
                </th>
                <td className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4">
                  {/* @ts-ignore */}
                  {drop?.location?.cost_place}
                </td>
                <td className="px-2 sm:px-6 py-1 sm:py-4">
                  {Number(
                    drop?.totalPrice ? drop?.totalPrice / 100 : 0
                  )?.toFixed(2)}{" "}
                  €
                </td>
                <td className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4">
                  {drop?.dropFeedback?.length ?? 0}
                </td>
                <td
                  className={`hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4 ${isApproved ? "text-green-500" : ""
                    } ${isPending ? "text-orange-500" : ""} ${isDeclined ? "text-red-500" : ""
                    }`}
                >
                  {drop?.status?.toUpperCase()}
                </td>
                <td className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4">
                  {dayjs(drop?.createdAt).format("DD/MM/YY HH:mm")}
                </td>
                <td className="px-2 sm:px-6 py-1 sm:py-4 flex items-center justify-end cursor-pointer">
                  <Tooltip content="Edit">
                    <EditIcon
                      onClick={() => navigate(`/edit-drop/${drop?._id}`)}
                      className="mr-3 sm:mr-7"
                    />
                  </Tooltip>
                  <Tooltip content="Delete">
                    <TrashIcon
                      onClick={() => {
                        const confirmDelete = window.confirm(
                          "Are you sure you want to delete this drop?"
                        );
                        if (confirmDelete) {
                          deleteDrop(drop._id as string, userId);
                        }
                      }}
                    />
                  </Tooltip>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};
